import { getInitials } from '@frontend/api-client';
import { type Client } from '@frontend/api-types';
import { useFeatureIsOn } from '@frontend/react';
import { safeCss } from '@frontend/web-utils';
import type { AvatarProps as MAvatarProps } from '@mantine/core';
import { Avatar as MAvatar } from '@mantine/core';
import type { AccessibilityLabelProps } from '../../types/accessibility';

export type AvatarProps = AccessibilityLabelProps &
  Omit<MAvatarProps, 'variant'> & {
    initials?: string;
    userInfo?: Client;
  };

export const Avatar = ({ accessibilityLabel, initials, userInfo, ...props }: AvatarProps) => {
  const { enabled: isGameplanPricingEnabled } = useFeatureIsOn('is_gameplan_pricing_enabled');
  return (
    <MAvatar
      aria-label={accessibilityLabel}
      classNames={{
        placeholder: isGameplanPricingEnabled
          ? safeCss('bg-neutral-950 text-captionBold text-cream-50')
          : safeCss('bg-surfaceBrand text-captionBold text-textAccent'),
        root: isGameplanPricingEnabled ? safeCss('bg-neutral-950 p-xs') : safeCss('bg-surfaceBrand p-xs'),
      }}
      color="blue"
      radius="xl"
      size="md"
      variant="filled"
      {...props}
    >
      {initials || (userInfo && getInitials(userInfo)) || ''}
    </MAvatar>
  );
};
